import { DatePipe } from "@angular/common";
import { HttpParams } from "@angular/common/http";

export class ListOfCertificates {

  requestNumber: number;
  certificateId: number;
  certificateType: CertificateType;
  certCa: string;
  clientIdentification: string;
  serialNumber: string;
  clientName: string;
  associatePersonIdentification: string;
  associatePersonName: string;
  clientCity: string;
  certReqId: string;
  startDate: Date;
  certStatus: CertificateStatus;
  isAllowActions: boolean;
}
export enum CertificateType {
  CQES = 'CQES',
  OTHER = 'OTHER'
}

export enum CertificateStatus {
  VALID = 'VALID',
  EXPIRED = 'EXPIRED',
  HOLDED = 'HOLDED',
  REVOKED = 'REVOKED',
  WAITING_ACTIVATION = 'WAITING_ACTIVATION',
  PENDING_HOLD = 'PENDING_HOLD',
  PENDING_RESTORE = 'PENDING_RESTORE',
  PENDING_REVOKE = 'PENDING_REVOKE',
  NOTACTIVATED = 'NOTACTIVATED'
}
export class SearchCertificateCriteria {
  requestNumber?: number;
  type?: CertificateType;
  serialNumber?: string;
  clientName?: string;
  clientIdentification?: string;
  associateName?: string;
  associateIdentification?: string;
  clientEmail?: string;
  clientPhone?: string;
  contractCode?: string;
  certStatusId?: CertificateStatus;
  offset?: number;
  limit?: number;

  order?: string;
  orderBy?: string;
  isRedirected?: boolean;
  hasPaging?: boolean;
  constructor() {
    this.offset = 0;
    this.limit = 10;
  }

  public toHttpParams(datepipe: DatePipe): HttpParams {
    let params = new HttpParams();
    Object.keys(this).forEach((key) => {
      if (key === 'offset') {
        const offset = this[key] ? this[key].toString() : '0';
        params = params.set(key, offset);
      } else if (this[key]) {
        let param = this[key];
        const strKey = '' + param;
        params = params.set(key, strKey);
      }
    });
    return params;
  }

  public reset() {
    this.requestNumber = null;
    this.type = null;
    this.serialNumber = '';
    this.clientName = '';
    this.clientIdentification = '';
    this.associateName = '';
    this.associateIdentification = '';
    this.clientEmail = '';
    this.clientPhone = '';
    this.contractCode = '';
    this.certStatusId = null;
    this.offset = 0;
    this.limit = 10;
    this.order = '';
    this.orderBy = '';
  }
};

export enum Roles {
  ADMIN = 'ADMIN',
  SUPER_ADMIN = 'SUPER_ADMIN',
  AGENT = 'AGENT',
  SUPER_AGENT = 'SUPER_AGENT',
  PAC_AGENT = 'PAC_AGENT',
  PAC_ADMIN = 'PAC_ADMIN',
  MRS_ADMIN = 'MRS_ADMIN',
  MRS_AGENT = 'MRS_AGENT',
  MRS_OTC_AGENT = 'MRS_OTC_AGENT',
  MRS_ADMIN_BNB = 'MRS_ADMIN_BNB',
  MRS_AGENT_BNB = 'MRS_AGENT_BNB',
  ESTORE_AGENT = 'ESTORE_AGENT',
  OPERATOR_FOR_SMART_CARD = 'OPERATOR_FOR_SMART_CARD',
  MRS_AGENT_OBB = 'MRS_AGENT_OBB'
}

export interface HardwareCertificatesFilters {
  type?: string;
  serialNumber?: string;
  clientName?: string;
  clientIdentification?: string;
  status?: string;
  fromStartDate?: string;
  toStartDate?: string;
  fromExpiryDate?: string;
  toExpiryDate?: string;
}

export interface PaginationParams {
  pageIndex: number; // zero-based page index
  pageSize: number;
  totalCount?: number;
}

export interface SortingParams {
  active: string; // column name
  direction: 'asc' | 'desc' | '';
}

export interface HardwareCertificatesQueryParams {
  filters: HardwareCertificatesFilters;
  pagination: PaginationParams;
  sorting?: SortingParams;
}

export interface managementRequestsI {
  request_number: number;
  action: string;
  created_on: Date;
  certificateHolderName: string;
  status: string;
}

